// extracted by mini-css-extract-plugin
export default {"createOrderPage":"ProductOrder_createOrderPage__9Hlfb","createOrderForm":"ProductOrder_createOrderForm__yx-M3"};